// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__lH_Zi","topBottomGutter":"Layout_topBottomGutter__-gNWr"};